export default __webpack_public_path__ + "static/media/marvel-app-logo.70522d84.svg";